export default __webpack_public_path__ + "static/media/skull.88931a62.png";